/** @module Enums */ /** typedoc */
var GenresEnum;
(function (GenresEnum) {
    GenresEnum["Alternative"] = "Alternative";
    GenresEnum["Audiobooks"] = "Audiobooks";
    GenresEnum["Blues"] = "Blues";
    GenresEnum["ChildrensMusic"] = "ChildrensMusic";
    GenresEnum["Classical"] = "Classical";
    GenresEnum["Comedy"] = "Comedy";
    GenresEnum["Country"] = "Country";
    GenresEnum["Dance"] = "Dance";
    GenresEnum["Electronic"] = "Electronic";
    GenresEnum["Folk"] = "Folk";
    GenresEnum["HipHopRap"] = "HipHopRap";
    GenresEnum["Holiday"] = "Holiday";
    GenresEnum["Inspirational"] = "Inspirational";
    GenresEnum["Jazz"] = "Jazz";
    GenresEnum["Latin"] = "Latin";
    GenresEnum["NewAge"] = "NewAge";
    GenresEnum["Opera"] = "Opera";
    GenresEnum["Pop"] = "Pop";
    GenresEnum["Rock"] = "Rock";
    GenresEnum["RBSoul"] = "RBSoul";
    GenresEnum["Reggae"] = "Reggae";
    GenresEnum["Soundtrack"] = "Soundtrack";
    GenresEnum["SpokenWord"] = "SpokenWord";
    GenresEnum["Vocal"] = "Vocal";
    GenresEnum["World"] = "World";
})(GenresEnum || (GenresEnum = {}));

export { GenresEnum };
